import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PaymentType } from '@models/events/enums/payment-type.enum';
import { TaxInvoiceDetailsComponent } from '@modules/events/components/event-payment/components/tax-invoice-details/tax-invoice-details.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModules } from '@utils/shared-modules';

@Component({
  selector: 'app-choose-payment',
  standalone: true,
  imports: [
    FormsModules,
    CommonModule,
    TranslateModule,
    MatTooltipModule,
    TaxInvoiceDetailsComponent,
    MatRadioButton,
    MatRadioGroup,
  ],
  templateUrl: './choose-payment.component.html',
  styleUrl: './choose-payment.component.scss',
})
export class ChoosePaymentComponent {
  @Input() chosenPayment?: PaymentType;
  @Input() billingAddressForm?: FormGroup;
  @Input() appearance: MatFormFieldAppearance = 'outline';
  @Output() paymentChosen = new EventEmitter<PaymentType>();
  @Output() showAddress = new EventEmitter();
  paymentTypes: PaymentType[] = PaymentType.getAll();
  showBillingAddress: boolean = false;

  constructor(private translateService: TranslateService) {}

  onShowAddress() {
    this.showAddress.emit();
    this.showBillingAddress = !this.showBillingAddress;
  }

  choosePayment(payment: PaymentType) {
    this.chosenPayment = payment;
    this.paymentChosen.emit(payment);
  }

  isDisabled(type: PaymentType) {
    const disabledTypes = [
      PaymentType.PAYMENT_LINK,
      PaymentType.PREPAID_CODE,
      PaymentType.CUSTOM,
    ];
    return disabledTypes.includes(type);
  }

  getPaymentTitle(payment: PaymentType) {
    const instant =
      'APP.BOOKING_SLOTS.PARTICIPANTS.ADD_PARTICIPANT_PAYMENT_TITLE.' + payment;
    return this.translateService.instant(instant);
  }

  getPaymentDescription(payment: PaymentType) {
    const instant =
      'APP.BOOKING_SLOTS.PARTICIPANTS.ADD_PARTICIPANT_PAYMENT_DESCRIPTION.' +
      payment;
    return this.translateService.instant(instant);
  }

  getPaymentHint(payment: PaymentType) {
    const instant =
      'APP.BOOKING_SLOTS.PARTICIPANTS.ADD_PARTICIPANT_PAYMENT_HINT.' + payment;
    return this.translateService.instant(instant);
  }

  protected readonly AddParticipantPaymentType = PaymentType;
  protected readonly PaymentType = PaymentType;
}
